import React, { useEffect, useState } from "react";
import "./Home.css";

import {
  FiCalendar,
  FiUser,
  FiArrowRight,
  FiArrowLeft,
  FiShield,
  FiHeart,
  FiStar,
} from "react-icons/fi";

const blogs = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dbb2hkjri/image/upload/f_auto,q_auto,w_1600/v1791891527/beffdd10-176c-4d14-a6a6-abbafcd54ce0_n13ppj.png",
    category: "RUDRAKSHA",
    title:
      "1 Mukhi Rudraksha: Who Should Wear It and Who Should Avoid It?",
    author: "Astro Logical Solutions",
    date: "13 October 2026",
    slug:
      "https://astrologicalsolutions.in/blog/8fba332c-eb5a-4b1a-b087-6e680add48da",
    description:
      "1 Mukhi Rudraksha is one of the most spiritually significant Rudraksha beads in traditional Rudraksha practices.",
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793182369/66904384-8608-4403-8a93-9b8dc5d971c2_rfy1lv.png",
    category: "RUDRAKSHA",
    title: "How to Identify an Original 1 Mukhi Rudraksha: 7 Checks",
    author: "Astro Logical Solutions",
    date: "28 Oct 2026",
    slug: "https://astrologicalsolutions.in/blog/34e0b5fc-6c7b-49b3-98c7-f28c9325b791", // Add the actual blog URL here
    description:
      "Buying a Rudraksha may be confusing, especially while you are looking for an genuine and actual bead. With such a lot of sorts to be had on line and offline.",
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793252607/7401c94c-82ea-4f46-a505-9403a9df8e2b_nmui0j.png",
    category: "RUDRAKSHA",
    title: "How to Wear 1 Mukhi Rudraksha: Mantra & Rituals",
    author: "Astro Logical Solutions",
    date: "28 Oct 2026",
    slug: "https://astrologicalsolutions.in/blog/440f4e4e-0a83-40b8-b4c7-e1775dfea6a5", // Add the actual blog URL here
    description:
      "The 1 Mukhi Rudraksha holds a special place in Hindu spiritual traditions because of its association with Lord Shiva.",
  },
];

export default function JournalSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % blogs.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const activeBlog = blogs[activeIndex];

  const nextBlog = () => {
    setActiveIndex((prev) => (prev + 1) % blogs.length);
  };

  const prevBlog = () => {
    setActiveIndex((prev) =>
      prev === 0 ? blogs.length - 1 : prev - 1
    );
  };

  // Open the actual blog URL when available.
  // Otherwise, use the local blog route.
  const getBlogUrl = (blog) => {
    return blog.slug || `/Blog/${blog.id}`;
  };

  return (
    <section className="journal-sec">
      <div className="journal-container">
        <div className="journal-main">

          {/* LEFT SIDE: BLOG LIST */}
          <div className="journal-left">
            <span className="journal-label">OUR BLOG</span>

            <h2>
              Wisdom for a <b className="bold"> Sacred &amp; Balanced Life</b>
            </h2>

            <p className="journal-intro">
              Explore insightful articles on spirituality, Vastu,
              astrology, sacred products, pooja traditions,
              gemstones, healing crystals and mindful living.
            </p>

            <div className="journal-list">
              {blogs.map((blog, index) => (
                <div
                  className={`journal-list-item ${
                    activeIndex === index ? "active" : ""
                  }`}
                  key={blog.id}
                  onClick={() => setActiveIndex(index)}
                >
                  <div className="journal-list-icon">
                    {index === 0 && <FiHeart />}
                    {index === 1 && <FiStar />}
                    {index === 2 && <FiShield />}
                  </div>

                  <div className="journal-list-content">
                    <h3>{blog.title}</h3>

                    <div className="journal-list-meta">
                      <span>
                        <FiUser />
                        {blog.author}
                      </span>

                      <i></i>

                      <span>
                        <FiCalendar />
                        {blog.date}
                      </span>
                    </div>
                  </div>

                  {/* CLICK ARROW TO OPEN BLOG PAGE */}
                  <a
                    href={getBlogUrl(blog)}
                    className="journal-small-arrow"
                    aria-label={`Read ${blog.title}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FiArrowRight />
                  </a>
                </div>
              ))}
            </div>

            <a href="/Blog" className="journal-all-btn">
              <span>View All Blogs</span>
              <FiArrowRight />
            </a>
          </div>

          <div className="journal-featured">
            <div
              className="journal-featured-image"
              key={activeBlog.id}
              style={{
                backgroundImage: `url(${activeBlog.image})`,
              }}
            >
              <div className="journal-featured-overlay"></div>

           

              <div className="journal-featured-content">
                {/* <h2>{activeBlog.title}</h2>

                <p>{activeBlog.description}</p>

                <a
                  href={getBlogUrl(activeBlog)}
                  className="journal-read-btn"
                >
                  <span>Read More</span>
                  <FiArrowRight />
                </a> */}
              </div>

              <button
                type="button"
                className="journal-slider-arrow journal-prev"
                onClick={prevBlog}
                aria-label="Previous Blog"
              >
                <FiArrowLeft />
              </button>

              <button
                type="button"
                className="journal-slider-arrow journal-next"
                onClick={nextBlog}
                aria-label="Next Blog"
              >
                <FiArrowRight />
              </button>

              <div className="journal-dots">
                {blogs.map((blog, index) => (
                  <button
                    type="button"
                    key={blog.id}
                    className={
                      activeIndex === index
                        ? "journal-dot active"
                        : "journal-dot"
                    }
                    onClick={() => setActiveIndex(index)}
                    aria-label={`Go to blog ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}